import { useState, useEffect, useRef } from 'react'

const UPDATE_DEBOUNCE = 1000

function useLocalStorage(key='settings', initialValue = {}, debounce=UPDATE_DEBOUNCE) {
  const timeoutId = useRef(null)

  const getValue = () => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      console.error(error)
      return initialValue
    }
  }
  const [storedValue, setStoredValue] = useState(getValue())

  useEffect(() => {
    setValue(getValue())
  }, [key])

  useEffect(() => {
    if (timeoutId.current) {
      window.clearTimeout(timeoutId.current)
    }

    if (!storedValue) {
      return
    }

    if (!debounce) {
      return
    }

    timeoutId.current = window.setTimeout(() => {
      window.localStorage.setItem(key, JSON.stringify(storedValue))
    }, debounce)

    return () => {
      if (timeoutId.current) {
        window.clearTimeout(timeoutId.current)
      }
    }
  }, [storedValue, debounce])

  const setValue = (value) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value
      setStoredValue(valueToStore)
      if (!debounce) {
        window.localStorage.setItem(key, JSON.stringify(valueToStore))
      }
    } catch (error) {
      console.error(error)
    }
  }

  return [storedValue, setValue]
}

export default useLocalStorage
